! function(name, module, context) {
    //>>excludeStart("requireTmpl", pragmas.requireTmpl);
    if (window.define)
        define('hotels/sorter',['libs/ct_view', 'common/sorter', 'hotels/filter'], module)
    else
        //>>excludeEnd("requireTmpl");
        context[name] = module(CT.View, CT.settings.sorter, CT.settings.filter)
}('sorter', function(View, commonSorters, filter) {

    var prop = function( /* String */ name, /* Object/Array */ context) {
        //var json = context || CT.cache[CT.settings.currentTab].jsonCopy.ht
        var fn;
        switch (name) {
            case 'radial':
            case 'exact':
                fn = function(hotel) {
                    return hotel.areaPOI === name
                };
                break;
            case 'ta':
                fn = function(hotel) {
                    if(CT.cache[CT.settings.currentTab].searchParams.all.tagsFilter){
                        return +(hotel.tar * 1000000 + hotel.tarev || 0)
                    }
                    return +(hotel.tar || 0)
                };
                break;
            case 'distance':
                fn = function(hotel) {
                    return CT.subProd === "wg" ? +(Math.floor(hotel.dt) || 0) : +(hotel.pil && hotel.pil[0])
                };
                break;
            case 'location':
                fn = function(hotel) {
                    return +(hotel.distanceFromLocation || 0);
                };
                break;
            case 'star':
                fn = function(hotel) {
                    return +(hotel.sr || 0)
                };
                break;
            case 'spl':
                fn = function(hotel) {
                    return hotel.spl ? 1 : 0;
                };
                break;
            case 'comm':
                fn = function(hotel) {
                    return +hotel.priceInfo.rms[0].agm;
                };
                break;
            case 'priceInfo':
                fn = function(hotel) {
                    return !!hotel.priceInfo
                };
                break;
            case 'price':
                fn = function(hotel) {
                    return CT.app !== 'dp' ? +(hotel.priceInfo !== undefined ? (hotel.bfo ? hotel.priceInfo.rms[0].tdt : hotel.priceInfo.rms[0].tot) : 0) : +hotel.priceInfo.pf
                };
                break;
            case 'deal':
                fn = function(hotel) {
                    return CT.app !== 'dp' ? +(hotel.priceInfo !== undefined ? hotel.priceInfo.rms[0].d : 0) : +hotel.priceInfo.ps
                };
                break;
            default:
                fn = function(hotel) {
                    return +(hotel[name] || 0)
                };
                break;
        }
        return fn;
    }

    var sorters = {
        sortByfeatured: function(dataList, sortType, sortOrder) {
            var arr = [];
            var tmp;
            var sortedData = _.sortBy(dataList, function(hotel) {
                if (sortType != 'featured' && arr.indexOf((tmp = prop(sortType)(hotel)) === -1)) {
                    arr.push(tmp);
                }
                return +hotel.p
            });
            return {
                toSort: (arr.length <= 1) ? false : true,
                data: sortedData
            }
        },
        //Added By Vijay Krishna For PRM-14800//Depends on the Property CT.isLocationEnabled
        sortByRadialDistnce: function(dataList, sortOrder) {
            var sortedData = _.sortBy(dataList, function(hotel) {
                return +hotel.distanceFromLocation;
            })
            return {
                toSort: true,
                data: sortedData
            };
        },
        applySecondarySort: function(secondarySort, a, b, sortOrder) {
            // console.log("secondarySort, a, b", secondarySort, a, b);
            var sortMultiplier = 1;
            if (sortOrder == 'desc') {
                sortMultiplier = -1;
            }
            // console.warn("window.secondarySortOrder", window.secondarySortOrder);
            if (secondarySort == "featured") {
                return a.p - b.p;
            } else if (secondarySort == "price" ||
                secondarySort == "ta" ||
                secondarySort == 'location' ||
                secondarySort == 'distance') {
                var sortFunction = prop(secondarySort);
                return (sortFunction(a) - sortFunction(b)) * sortMultiplier;
            } else {
                // default secondarySort is featured!
                return a.p - b.p;
            }
        },
        //Sort By tags priority
        sortByTagPriority: function(hotels, sortType, sortOrder) {
            console.log("sortByTagPriority hotels, sortType, sortOrder", hotels, sortType, sortOrder);
            $("#div-hotelTagsSeperatorMessage").show();
            if (!hotels) {
                return [];
            }
            // var isSortByTagsPriority;
            // isSortByTagsPriority = (window.showTags && CT.tagsData && CT.cache[CT.settings.currentTab].searchParams.all.tagsFilter) ? true : false;
            // if (!isSortByTagsPriority || (CT.tagsSelected && CT.tagsSelected.length === 0)) {
            //     $("nav.hotelsList").hide();
            //     var filterEleHeight = $("div.filters:visible").height();
            //     var html = CT.to_html('SRPTagsExlpainerTpl');
            //     $("div.tagsExplainer").height(filterEleHeight).html(html).show();
            //     return [];
            // }
            if (!CT.cache[CT.settings.currentTab].searchParams.all.tagsFilter) {
                return [];
            }
            var allTags = [];
            if (CT.tagsData) {
                allTags = _.map(CT.tagsData, function(tag) {
                    return tag.tagId;
                })
            }

            // function getPrioritySum(tagList){
            //     return _.reduce(tagList,function(prev,curr){
            //         return prev + CT.tagsPriorityHash[curr];
            //     },0)
            // }

            // function isMorePrioritised(a,b){
            //     //return if a will take priority or not in case of length is same of and b;
            //     var isMorePriority =  false,
            //         prioritySumA = getPrioritySum(a),
            //         prioritySumB = getPrioritySum(b);
            //     if(prioritySumA > prioritySumB){
            //         isMorePriority = true;
            //     }
            //     return isMorePriority;
            // }

            var secondarySort = window.secondarySort || "featured";
            var noOfTagsSelected = CT.cache[CT.settings.currentTab].searchParams.all.tagsFilter.split('tag').length - 1;
            // console.log("noOfTagsSelected", noOfTagsSelected);
            // console.warn("secondarySort", secondarySort);
            hotels = _(hotels).sort(function(a, b) {
                if (a.selectedTags && b.selectedTags) {
                    var selectedA = a.selectedTags,
                        selectedB = b.selectedTags,
                        aLen = selectedA.length,
                        bLen = selectedB.length;
                    // if (!aLen || !bLen) {
                    //     console.warn("This is the problem, 0 case!!!");
                    // }

                    if (aLen == noOfTagsSelected && bLen == noOfTagsSelected) {
                        // sorts full match and partial match
                        return sorters.applySecondarySort(secondarySort, a, b, sortOrder);
                    } else if (aLen == noOfTagsSelected) {
                        // sorts full match and partial match
                        return -1;
                    } else if(bLen == noOfTagsSelected) {
                        // sorts full match and partial match
                        return 1;
                    } else if(bLen && !aLen) {
                        // sort tagged and non-tagged hotels
                        return 1;
                    } else if(aLen && !bLen) {
                        // sort tagged and non-tagged hotels
                        return -1;
                    } else {
                        if(secondarySort == "featured"){
                        if (bLen - aLen) {
                            // sort hotels by length
                            return bLen - aLen
                        }
                        } else {
                            return sorters.applySecondarySort(secondarySort, a, b, sortOrder);
                        }
                        // case B is flat_sort,
                        // case A is sort by selected when equal length(same number of tags)

                        // if(isMorePrioritised(selectedA,selectedB)){
                        //     return -1;
                        // }else{
                        //     return 1;
                        // }
                    }
                } else if (a.selectedTags && a.selectedTags.length && !b.selectedTags) {
                    return -1;
                } else if (!a.selectedTags && b.selectedTags && b.selectedTags.length) {
                    return 1;
                } else {
                    // if (!a.selectedTags && !b.selectedTags) {
                    //     console.log("Taken care of by the else clause!!!");
                    //     if (a.nm == "The Oberoi Bengaluru" || b.nm == "The Oberoi Bengaluru") {
                    //         console.log("a, b", a, b);
                    //     }
                    // }
                    return sorters.applySecondarySort(secondarySort, a, b, sortOrder);
                }
            }).value();
            // console.log("window.hasHundredPercentMatch", window.hasHundredPercentMatch);
            // console.log("hotels[hotels.length - 1].selectedTags", hotels[hotels.length - 1].selectedTags);
            // console.log("hotels", hotels);
            return hotels;
        },

        sortBySplRateAsc: function(b, a) {
            return a.spl || (b.p - a.p);
        },

        sortBySplRateDesc: function(a, b) {
            a1 = (a.spl ? 1 : 0);
            b1 = (b.spl ? 1 : 0);

            return a1 < b1;
        },


        separateUnavail: function(listItems, groupFunc) {
            return _.groupBy(listItems, groupFunc || function(li) {
                return $(li).attr('data-price') == 0
            });
        },




        /**
         *  Grouping the list.
         *  Each group is sorting by featured.[sub sort for star and ta-star]
         */
        sortAll: function( /* Array (ht) */ hotels, sortType, sortOrder) {
            if (!hotels) return []

            var tmp;

            //apply featured sort first so that the sub sort will be featured incase of any other sort
            //  tmp = this.sortByfeatured(hotels, sortType, sortOrder);
            hotels = hotels;

            if (sortType === 'star' || sortType === 'ta') {
                hotels = _.groupBy(hotels, prop(sortType));
                if(sortType === 'ta'){
                    //HOTCON-432 TARating Sort to be enhanced by using # of reviews as params
                    //Sort each TA rating group with # of TA reviews 
                    var temp = {};
                    temp["0"]= hotels["0"];
                    for(var i=1;i<5.5;i=i+0.5){
                        temp[i.toString()] = _.sortBy(hotels[i.toString()], 'tarev').reverse()
                    }
                    hotels = temp;
                }
                //asc, desc logic
                var sObj = [],
                    s;

                if (sortOrder == "desc") {
                    for (var i = 5; i >= 0; i--) {
                        s = [];
                        if (hotels[i + '.5']) {
                            s = s.concat(hotels[i + '.5']);
                        }
                        s = s.concat(hotels[i] || []);
                        if (s) sObj = sObj.concat(s);
                    }
                } else {
                    for (var i = 0; i < 6; i++) {
                        s = hotels[i] || [];
                        if (hotels[i + '.5']) {
                            s = s.concat(hotels[i + '.5']);
                        }
                        if (s) sObj = sObj.concat(s);
                    }
                }

                hotels = sObj; //_(sObj).reduce(function(memo, val){ return memo.concat(val) }, [])

            } else {
                if (sortOrder == 'asc')
                    hotels = _(hotels).sortBy(prop(sortType)).value();
                else
                    hotels = _(hotels).sortBy(prop(sortType)).reverse().value();
            }


            return hotels;
        },


        //not using
        groupByLocality: function( /* Array */ htArr) {
            var /* Array */ data_exact = _.groupBy(htArr, prop('exact'));
            var /* Array */ data_radial = _.groupBy(data_exact["false"], prop('radial'));
            var /* Array */ dont_show = data_radial["false"];
            return [data_exact['true'], data_radial['true'], dont_show]
        },

        /*
         * Updated the browser url query params to persist the filters informtion, with is used for managing filter states.
         */
        setUrlParams: function(paramsHash) {
            var copyingFilterParams = CT.cache[CT.settings.currentTab].searchParams.all.appliedFiltersParmas;
            delete CT.cache[CT.settings.currentTab].searchParams.all.appliedFiltersParmas;
            var searchParams = _.deserialize(CT.cache[CT.settings.currentTab].searchParams.all); // TODO change window.location.href to data.url
            $(["sort", "sort_order"]).each(function(i, key) {
                searchParams[key] = paramsHash[key];
            });

            //Hack
            if (searchParams["sort"] == "featured" || searchParams["sort"] == "tags") {
                delete searchParams["sort_order"]
            }
            if (CT.cache[CT.settings.currentTab].viewType) {
                searchParams["view"] = CT.cache[CT.settings.currentTab].viewType;
            }
            if (CT.subProd && CT.subProd == "wg") {
                delete searchParams.city;
            }
            CT.settings.routes.navigate('/results?' + _.serialize(searchParams), {
                trigger: false,
                replace: true
            });

            CT.cache[CT.settings.currentTab].searchParams.all.appliedFiltersParmas = copyingFilterParams;
            CT.cache[CT.settings.currentTab].searchParams.all = searchParams;

            return this;
        },
        calculateDistanceString: function(hotelsList, address) {
            var searchedPoiAddress = address
            _.each(hotelsList, function(item) {
                if (item.hasSpriteIcon && item.classToarea) {
                    delete item.hasSpriteIcon;
                    delete item.classToarea;
                } else {
                    if (item.distanceFromAreaString)
                        delete item.distanceFromAreaString;
                }
                if (item.areaSearch) {
                    item.areaSearch = false;
                }
                if (item.distanceFromLocation)
                    delete item.distanceFromLocation;
                if (item.latlng) {
                    var hotelLat = item.latlng[0];
                    var hotelLng = item.latlng[1];
                    var distanceFromArea = CT.utils.helperFunctions.getDistanceFromLatLonInKm(CT.cache[CT.settings.currentTab].latitude, CT.cache[CT.settings.currentTab].longitude, hotelLat, hotelLng);
                    var locationInMetres = distanceFromArea * 1000;
                    item.isgoogleSearch = true;
                    CT.utils.helperFunctions.addLocationDetails(item, {
                        area: searchedPoiAddress,
                        lat: CT.cache[CT.settings.currentTab].latitude,
                        lng: CT.cache[CT.settings.currentTab].longitude
                    });
                    item.distanceFromLocation = distanceFromArea;
                    if (distanceFromArea) {
                        if (locationInMetres > 1000)
                            item.distanceFromAreaString = distanceFromArea.toFixed(1) % 1 !== 0 ? (distanceFromArea.toFixed(1) + " km from " + searchedPoiAddress) : (distanceFromArea.toFixed() + " km from " + searchedPoiAddress);
                        else
                            item.distanceFromAreaString = distanceFromArea.toFixed(1) + " km from " + searchedPoiAddress;
                    }
                } else
                    item.distanceFromLocation = 6372;
            })
            return hotelsList;
        },

        // @desc Sort 'hotels' by 'sortType' and 'sortOrder'
        setSortedHotels: function( /* Hash */ hotels, /* String */ sortType, /* String */ sortOrder) { // NOTE: 'hotels' is the filtered cached json e.g { exact : [], others : [] }
            // console.log("sortOrder", sortOrder);
            // console.log("sortType", sortType);
            // console.log("hotels", hotels);

            // Set showAllPoiClicked to true to display all poi always
            CT.cache[CT.settings.currentTab].showAllPoiClicked = true;
            var $currentResultView = $('#ResultContainer_' + CT.settings.currentTab)
            var $currentTopSorter = $currentResultView.find("section.secondaryBar nav.sorters a.current").last();
            // console.log("setSortedHotels", "Stuff got executed!!!!!");

            $("#div-hotelTagsSeperatorMessage").hide();
            $("nav.hotelsList").show();
            $("div.tagsExplainer").hide();
            var isFeatured = sortType === 'featured'
            var /* Hash */ splitList,
                /* Array */
                sortedAvailList,
                /* Array */
                sortedUnavailList;
            var cache = CT.cache[CT.settings.currentTab];

            var radialList = hotels.others,
                areaList = hotels.exact
            if (CT.cache[CT.settings.currentTab].longitude != "" && CT.cache[CT.settings.currentTab].latitude != "") {
                if (CT.cache[CT.settings.currentTab].homePageAutoCompleteSelectedVal == true &&
                    CT.isLocationEnabled &&
                    CT.cache[CT.settings.currentTab].pointOfIntrestValue != "" &&
                    CT.cache[CT.settings.currentTab].showFewHotelsDistance != "" &&
                    CT.isLocationEnabled == true) {
                    var searchedPoiAddress = CT.cache[CT.settings.currentTab].pointOfIntrestValue
                    if (areaList && areaList.length > 0) {
                        areaList = this.calculateDistanceString(areaList, searchedPoiAddress)
                    }
                    if (radialList && radialList.length > 0) {
                        radialList = this.calculateDistanceString(radialList, searchedPoiAddress)
                    }
                }
            }
            if (CT.cache[CT.settings.currentTab].homePageAutoCompleteSelectedVal == false) {
                _.each(areaList, function(item) {
                    if (item.hasSpriteIcon && item.classToarea) {
                        delete item.hasSpriteIcon;
                        delete item.classToarea;
                    } else {
                        if (item.distanceFromAreaString)
                            delete item.distanceFromAreaString;
                    }
                    if (item.areaSearch) {
                        item.areaSearch = false;
                    }
                    if (item.distanceFromLocation)
                        delete item.distanceFromLocation;
                })
            }

            var availGroupedList = _.groupBy(areaList, prop('priceInfo')); // avail and unavail list as 'true' and 'false' properties respectively
            if (isFeatured) {
                sortedAvailList = sorters.sortByfeatured(availGroupedList["true"], sortType, sortOrder).data;
                sortedUnavailList = sorters.sortByfeatured(availGroupedList["false"], sortType, sortOrder).data;
            } else if (sortType == "spl") {
                sortedUnavailList = [];
                if (sortOrder == "asc" && !$.isEmptyObject(availGroupedList)) {
                    sortedAvailList = availGroupedList["true"].sort(sorters.sortBySplRateAsc);
                    sortedUnavailList = availGroupedList["false"].sort(sorters.sortBySplRateAsc);
                } else if (!$.isEmptyObject(availGroupedList)) {
                    sortedAvailList = availGroupedList["true"].sort(sorters.sortBySplRateDesc);
                    sortedUnavailList = availGroupedList["false"].sort(sorters.sortBySplRateDesc);
                }
            } else if (sortType == "tags") {
                sortedAvailList = sorters.sortByTagPriority(availGroupedList["true"], "tags", sortOrder);
                sortedUnavailList = sorters.sortByTagPriority(availGroupedList["false"], "tags", sortOrder) || [];
            } else {
                sortedAvailList = sorters.sortAll(availGroupedList["true"], sortType, sortOrder);
                sortedUnavailList = sorters.sortAll(availGroupedList["false"], sortType, sortOrder);
            }

            var availGroupedListOthers = _.groupBy(radialList, prop('priceInfo')); // avail and unavail list as 'true' and 'false' properties respectively
            if (CT.isLocationEnabled == true) {
                if (!$.isEmptyObject(availGroupedListOthers) && (sortType == "location" || (sortType != "price" && sortType != "deal" && sortType != "ta" && sortType != "tags"))) {
                    if (availGroupedListOthers["true"]) {
                        sortedAvailListOthers = sorters.sortByRadialDistnce(availGroupedListOthers["true"], 'asc').data;
                    } else {
                        sortedAvailListOthers = [];
                    }
                    if (availGroupedListOthers["false"]) {
                        sortedUnavailListOthers = sorters.sortByRadialDistnce(availGroupedListOthers["false"], 'asc').data;
                    } else {
                        sortedUnavailListOthers = [];
                    }
                } else if (sortType == "spl") {
                    sortedUnavailListOthers = [];
                    if (sortOrder == "asc" && !$.isEmptyObject(availGroupedListOthers)) {
                        sortedAvailListOthers = availGroupedListOthers["true"].sort(sorters.sortBySplRateAsc);
                        sortedUnavailListOthers = availGroupedListOthers["false"].sort(sorters.sortBySplRateAsc);
                    } else if (!$.isEmptyObject(availGroupedListOthers)) {
                        sortedAvailListOthers = availGroupedListOthers["true"].sort(sorters.sortBySplRateDesc);
                        sortedUnavailListOthers = availGroupedListOthers["false"].sort(sorters.sortBySplRateDesc);
                    }
                } else {
                    sortedAvailListOthers = sorters.sortAll(availGroupedListOthers["true"], sortType, sortOrder);
                    sortedUnavailListOthers = sorters.sortAll(availGroupedListOthers["false"], sortType, sortOrder);
                }
            } else {
                if (isFeatured) {
                    sortedAvailListOthers = sorters.sortByfeatured(availGroupedListOthers["true"], sortType, sortOrder).data;
                    sortedUnavailListOthers = sorters.sortByfeatured(availGroupedListOthers["false"], sortType, sortOrder).data;
                } else if (sortType == "spl") {
                    sortedUnavailListOthers = [];
                    if (sortOrder == "asc" && !$.isEmptyObject(availGroupedListOthers)) {
                        sortedAvailListOthers = availGroupedListOthers["true"].sort(sorters.sortBySplRateAsc);
                        sortedUnavailListOthers = availGroupedListOthers["false"].sort(sorters.sortBySplRateAsc);
                    } else if (!$.isEmptyObject(availGroupedListOthers)) {
                        sortedAvailListOthers = availGroupedListOthers["true"].sort(sorters.sortBySplRateDesc);
                        sortedUnavailListOthers = availGroupedListOthers["false"].sort(sorters.sortBySplRateDesc);
                    }
                } else if (sortType == "tags") {
                    sortedAvailListOthers = sorters.sortByTagPriority(availGroupedList["true"], "tags", sortOrder);
                    sortedUnavailListOthers = sorters.sortByTagPriority(availGroupedList["false"], "tags", sortOrder) || [];
                } else {
                    sortedAvailListOthers = sorters.sortAll(availGroupedListOthers["true"], sortType, sortOrder);
                    sortedUnavailListOthers = sorters.sortAll(availGroupedListOthers["false"], sortType, sortOrder);
                }
            }
            //console.clear();
            // sort by distanceFromLocation in case location is secondary sort
            if (CT.cache[CT.settings.currentTab].locationUrlSearch == true && CT.isLocationEnabled == true && sortType != 'tags') {
                if (sortedAvailList.length == 0 && sortedAvailListOthers.length > 0) {
                    sortedAvailList = sortedAvailListOthers;
                    sortedUnavailList = sortedUnavailListOthers;
                    sortedAvailListOthers = []
                }
                if (sortedUnavailList.length == 0 && sortedUnavailListOthers.length > 0) {
                    sortedUnavailList = sortedUnavailListOthers;
                    sortedUnavailListOthers = []
                }
            }
            if ($("#ResultContainer_" + CT.settings.currentTab).find('nav.showFewFilter input').attr('checked') && CT.isLocationEnabled == true && (sortType == "location")) {
                sortedAvailList = _.sortBy(sortedAvailList, 'distanceFromLocation')
            }

            if (CT.cache[CT.settings.currentTab].plceselected == true && CT.isLocationEnabled == true) {
                $("#ResultContainer_" + CT.settings.currentTab).find('nav.showFewFilter input').attr('checked', true)
            }
            if (CT.cache[CT.settings.currentTab].plceselected == true &&
                $('nav.showFewFilter input').attr('checked') &&
                CT.cache[CT.settings.currentTab].showFewHotelsDistance != "" &&
                CT.isLocationEnabled == true &&
                CT.cache[CT.settings.currentTab].arealDistancegreater != true &&
                sortType != 'tags') {
                // var distance = CT.cache[CT.settings.currentTab].showFewHotelsDistance ? parseInt(CT.cache[CT.settings.currentTab].showFewHotelsDistance) : "";
                var distance = 99999999; // Assumed max distance!
                var sortedTotalHotels = sortedAvailList;
                if (CT.cache[CT.settings.currentTab].isGoogleHotelNameSearch) {
                    var tempSortedUnavailableHotels = _.filter(sortedUnavailList, function(hotel) {
                        if (distance != "" && hotel.distanceFromLocation != "") {
                            if (hotel.distanceFromLocation <= googleHotelSearchMaxDistane) {
                                return true
                            }
                        }
                    });
                    sortedTotalHotels = sortedTotalHotels.concat(tempSortedUnavailableHotels)
                }
                sortedAvailList = _.filter(sortedTotalHotels, function(hotel) {
                    if (distance != "" && hotel.distanceFromLocation != "") {
                        if (hotel.distanceFromLocation <= distance) {
                            return true
                        }
                    }
                });
            }
            if (CT.cache[CT.settings.currentTab].homePageAutoCompleteSelectedVal == true && CT.isLocationEnabled == true && (sortType == "location")) {
                sortedAvailList = _.sortBy(sortedAvailList, 'distanceFromLocation')
            }
            if (CT.cache[CT.settings.currentTab].showFewHotelsDistance == "" && CT.cache[CT.settings.currentTab].plceselected == false && CT.cache[CT.settings.currentTab].showAllPoiClicked == true) {
                $("#ResultContainer_" + CT.settings.currentTab).find('nav.showFewFilter input').attr('checked', false)
            }
            if ($("#ResultContainer_" + CT.settings.currentTab).find('nav.sorters a.featuredSort').hasClass('current') && sortType == 'featured' && CT.isLocationEnabled) {
                sortedAvailList = sorters.sortByfeatured(sortedAvailList, sortType, sortOrder)
                sortedAvailList = sortedAvailList.data
            }
            if (CT.cache[CT.settings.currentTab].plceselected == true &&
                CT.isLocationEnabled == true && sortType == "featured" &&
                CT.cache[CT.settings.currentTab].firsTimePlaceSelected == true) {
                sortedAvailList = _.sortBy(sortedAvailList, 'distanceFromLocation')
            }
            if ($("#ResultContainer_" + CT.settings.currentTab).find('nav.sorters a.location').hasClass('sortAsc') && sortType !== "tags") {
                sortedAvailList = _.sortBy(sortedAvailList, 'distanceFromLocation')
                $("#ResultContainer_" + CT.settings.currentTab).find('nav.sorters a.sortAsc').css('padding-right', '5px')
            } else if ($("#ResultContainer_" + CT.settings.currentTab).find('nav.sorters a.location').hasClass('sortDes') && sortType !== "tags") {
                sortedAvailList = _.filter(sortedAvailList, function(hotel) {
                    return (hotel.latlng && hotel.latlng.length > 0)
                })
                $("#ResultContainer_" + CT.settings.currentTab).find('nav.sorters a.sortDes').css('padding-right', '5px')
                sortedAvailList = sortedAvailList.reverse()
            }
            if (($("#ResultContainer_" + CT.settings.currentTab).find('nav.showFewFilter input').attr('checked') ||
                    CT.cache[CT.settings.currentTab].plceselected == true ||
                    CT.cache[CT.settings.currentTab].showAllPoiClicked == true) && CT.isLocationEnabled == true) {
                $("#ResultContainer_" + CT.settings.currentTab).find('.selectSortersClick').find("option[value='location']").show()
            } else {
                $("#ResultContainer_" + CT.settings.currentTab).find('.selectSortersClick').find("option[value='location']").hide()
            }

            //console.log({ exact : sortedAvailList, radial : sortedAvailListOthers, unAvail : sortedUnavailList.concat(sortedUnavailListOthers) });
            return CT.cache[CT.settings.currentTab].sortedHt = {
                exact: sortedAvailList,
                radial: sortedAvailListOthers,
                unAvail: _.unique(sortedUnavailList.concat(sortedUnavailListOthers))
            };
        },
        getSortedHotels: function() {
            return CT.cache[CT.settings.currentTab].sortedHt;
        }
    }
    var sorterViewSettings = $.extend(commonSorters, {
        events: {
            'click nav.sorters ul li a': 'sortUIByTopBar'
            //,'click input[type="checkbox"]' : 'sortUIByLocality'
        },

        /**
         * updateSorters - presets the sortee elements from url params
         * @param params sorter values derived from url params
         * @returns sorter
         */
        updateSorterBar: function(params) {
            var self = this;

            function getSortType() {
                //TODO :  move to common place
                //Map between url and code.
                var sorterTypes = {
                    "price": "price",
                    "featured": "featured",
                    "deal": "deal",
                    "ta": "ta",
                    "star": "star",
                    "location": "location",
                    "tags": "tags"

                };
                //change back the orders asc to have asc class
                var sortOrders = {
                    'asc': 'sortAsc',
                    'desc': 'sortDes',
                    'default': ''
                }

                if (params.id == "featured" || params.id == "location") {
                    params.order = "";
                }
                return {
                    el: sorterTypes[(params.id || 'featured')],
                    orderClass: sortOrders[(params.order || 'default')],
                    order: (params.order || 'asc')
                }
            }

            var sortType = getSortType();
            window.sortType = sortType;

            self.$el.find(".sorters a")
                .removeClass("current")
                .end().find("[data-sort='" + sortType.el + "']")
                .addClass('current')
                .removeClass('sortAsc sortDes')
                .addClass(sortType.orderClass);

            if (window.isMobileUA) {
                self.$el.css("display", "");
            }

            return sortType;
        },
        //@todo - move to common
        sortObj: {
            "featured": "featured",
            'star': "star",
            "price": "price",
            "ta": "tastar",
            "deal": "ps",
            "location": "location",
            "tags": "tags"
        },

        /* ====  Updating sorter classes ======== */
        toggleSortOrder: function($clicked, sortType) {
            var upClass = 'sortAsc',
                downClass = 'sortDes';
            var isDown = $clicked.hasClass(downClass)
            //if(!$active[0]) $clicked.addClass('current').addClass(sortType === 'featured'? '' : upClass)
            if ((sortType == 'price' || sortType == 'location') && !($clicked.hasClass(downClass) || $clicked.hasClass(upClass))) {
                /*if(CT.subProd && CT.subProd == "wg" && sortType == 'price'){
                    $clicked.addClass(downClass);
                }else{
                    $clicked.addClass(upClass);
                }*/
                $clicked.addClass(upClass);
            } else {
                $clicked.removeClass(isDown ? downClass : upClass).addClass(isDown ? upClass : downClass)
            }
            /*else //TODO some edge case
            (altVal === 'price') ? $ele.removeClass(upClass).addClass(downCls) : $ele.removeClass(downCls).addClass(upClass);*/
            return this
        },
        updateClasses: function( /* String */ sortType, /* jQuery */ $sortButton) {
            var $active, $clicked
            if (!$sortButton) {
                $active = $clicked = this.$el.find('.sorters a').first()
            } else {
                $clicked = $sortButton // will be [] in case of page load
                $active = this.$el.find('.sorters a.current')
            }
            var upDownClass = 'sortAsc sortDes';
            if ($active[0] !== $clicked[0]) {
                $active.removeClass('current')
                $active.removeClass(upDownClass)
                $clicked.addClass('current')
            } else $active.addClass('current') // page load case

            if (!(sortType == 'featured' || sortType == 'tags'))
                this.toggleSortOrder($clicked, sortType)

            return this
        },
        /* ====  Updating sorter classes ======== */
        addSeparators: function(id) {
            if (availList.length > 0) {
                this.$mid.trigger('separator.add', [CT.messages[CT.app].separatorMsgs.radial, 'before', id]);
            } else if (unavailList.length > 0) {
                this.$mid.trigger('separator.add', [CT.messages[CT.app].separatorMsgs.radial, 'before', $(unavailList[0]).attr('id')]);
            }
        },
        // click handler =====================================================================================================================================================================
        sortUIByTopBar: function(e) {
            // console.warn("sortUIByTopBar");
            CT.cache[CT.settings.currentTab].firsTimePlaceSelected = false
            var /* jQuery sorter link */ $sortButton, currentSortOrder, mixpanelSortOrder, mixpanelSortType;
            if (e && e.preventDefault) {
                //hide nearby cities notification
                $('#ResultContainer_' + CT.settings.currentTab).trigger('nearByNotification.hide');
                e.preventDefault()
                $sortButton = $(e.target)
            } else
                $sortButton = (this.$el.find('a.current').length > 0) ? this.$el.find('a.current') : this.$el.find("nav.sorters a").first()

            this.$resultDiv = $('#ResultContainer_' + CT.settings.currentTab);
            // console.log("$sortButton.attr('data-sort')", $sortButton.attr('data-sort'));

            var currentSortType = $sortButton.attr('data-sort');
            this.$resultDiv.find(".selectSorters").last().find("select").val(currentSortType);
            
            // if (currentSortType == 'tags') {
            //     this.updateClasses('featured', $sortButton);
            // } else {
            // }
            this.updateClasses(currentSortType, $sortButton);
            
            /*
            if(currentSortType === 'price') currentSortOrder = $sortButton.hasClass('sortDes')? 'desc' : 'asc'
            else currentSortOrder = $sortButton.hasClass('sortDes')? 'desc' : 'asc'
            */
            currentSortOrder = $sortButton.hasClass('sortDes') ? 'desc' : 'asc'
            mixpanelSortOrder = currentSortOrder;

            if (e && currentSortType !== "location") {
                sorters.setUrlParams({
                    sort: currentSortType,
                    sort_order: currentSortOrder
                }); // update url params only when sorters are clicked
            }
            
            // console.log("setSortedHotels 1");
            if (CT.cache[CT.settings.currentTab].searchParams.all.tagsFilter) {
                // .split("tag").length - 1;
                // console.log("I'm in here!!!!!!!!");
                if (currentSortType == 'tags' && !window.secondarySort) {
                    // console.warn("Setting sort to featured!");
                    window.secondarySort = 'featured';
                } else if (currentSortType && currentSortType != 'tags') {
                    // console.warn("Setting sort to currentSortType!", currentSortType);
                    window.secondarySort = currentSortType;
                }
                currentSortType = 'tags';
            }
            var /* Array */ sortedHotels = sorters.setSortedHotels(this.getFilteredHotels(), currentSortType, currentSortOrder)
            this.$resultDiv.trigger('results.update', [sortedHotels, {
                idx: 0
            }]);

            if (!CT.cache[CT.settings.currentTab].viaToolBarControls) {
                var label = CT.cache[CT.settings.currentTab].paramsForGA,
                    action = '';
                mixpanelSortType = 'sort_' + currentSortType;
                currentSortType = _.capitalize(currentSortType);
                if (currentSortType === "Price" || currentSortType === "Star" || currentSortType === "Ta" ||
                    currentSortType === "Featured") {
                    if (currentSortType === "Ta") {
                        currentSortType = "TA";
                        mixpanelSortType = 'sort_' + currentSortType + 'rating';
                    }
                    currentSortOrder = currentSortOrder === "asc" ? "LH" : "HL";
                    if (currentSortType !== "Featured")
                        label = currentSortOrder;
                }
                action = 'H_Sort_' + currentSortType;
                CT.utils.helperFunctions.trackGAEventWrapper('Hotels_TR', action, label, '100');
                // var trackObj = {};
                // if (window.locationselectedMixpanel) {
                //     trackObj["sortType"] = "Location";
                //     trackObj["sortValue"] = CT.cache[CT.settings.currentTab].viewType == "map" ? $('input.mapAutocomplete:last').val() : this.$el.find("#showNearByBox").val();
                //     trackObj["propertyCount"] = "N/A";
                //     trackObj["autocompleteType"] = "N/A";
                //     trackObj["placeType"] = "N/A";
                // } else {
                //     trackObj["sortType"] = mixpanelSortType;
                //     trackObj["sortValue"] = currentSortOrder
                //     trackObj["propertyCount"] = "N/A";
                //     trackObj["autocompleteType"] = "N/A";
                //     trackObj["placeType"] = "N/A";
                // }
                // CT.utils.helperFunctions.trackMixpanelEvent('Hotel_sort_applied', trackObj);
                var claverTapObj = {
                    "sortType": currentSortType,
                    "sortValue": currentSortOrder,
                    "locationSearched": CT.cache[CT.settings.currentTab].searchedLocation ? CT.cache[CT.settings.currentTab].searchedLocation : "N/A"
                };
                CT.utils.helperFunctions.trackClaverTapEvtHotel("Hotel_SRP_Sort_Applied", claverTapObj);
                window.locationselectedMixpanel = false
                if (window.moengageEnabled && CT.utils.moengageTrackingObj) {
                    var sorList = {
                        "Featured": "f",
                        "Price": "p",
                        "Deal": "s",
                        "Ta": "r",
                        "TA": "r",
                        "Star": "r",
                        "Distance": "d"
                    }
                    var moeSortType = (sorList[currentSortType]) ? sorList[currentSortType] : "";
                    var sortMoengageTrackingObj = CT.utils.moengageTrackingObj;
                    sortMoengageTrackingObj.srt = moeSortType;
                    CT.utils.helperFunctions.tpTrack({
                        'tp': 'moengage',
                        'category': 'hsa',
                        'values': sortMoengageTrackingObj
                    });
                }
            }
            CT.cache[CT.settings.currentTab].viaToolBarControls = false;
            //Once the Sorting is done Scroll the results up
            $(window).scrollTop(0);
        },
        // click handler =====================================================================================================================================================================
        sortUIByLocality: function(e) {
            var /* jQuery button */ $sortButton = $(e.target),
                /* String */
                sortType = $sortButton.attr('data-sort');
            // console.log("setSortedHotels 2");
            _.each(sorters.groupByLocality(this.getFilteredHotels()), function(array, idx) { // 'array' will be exact, radial and unmatched hotels in this sequence
                sorters.setSortedHotels(array, idx)
            })
            this.$resultDiv = $('#ResultContainer_' + CT.settings.currentTab);
            this.$resultDiv.trigger('results.update', [this.getSortedData(), {
                idx: 0
            }])
        }
    });


    var sorterConstructor = function() {
        this.$el = $("#ResultContainer_" + CT.settings.currentTab).find("section.secondaryBar, .filters nav.area")
    }

    sorterConstructor.prototype = sorterViewSettings
    /**  Module execution begins here **/
    CT.subscribe('sorters.init', function( /* Hash */ paramsHash, /* View */ currentResultView) {
        //console.log('inside sorters init', filteredHt)
        //TODO - make sorter object common - Parag
        var c = new sorterConstructor()
        c.getFilteredHotels = filter.getData
        var sorterView = View(c) /*.extend(sorter);*/
        //sorterView.parentResultView = currentResultView
        //console.log('sorter view', sorterView, sorterView.prototype)
        var sortType = sorterView.updateSorterBar(sorterView.getSorterParams(CT.cache[CT.settings.currentTab].searchParams.all)) /*.updateClasses('featured')*/ //updateClasses logic is taken care by updateSorterBar
        //var /* Array */ sortedHotels = sorters.setSortedHotels(filteredHt, sortType.el, sortType.order)
        //currentResultView.$el.trigger('results.update', [sortedHotels])
        //TODO: above 2 lines can be converted to a single line, but there were some issues in the checkavailabilty flow in doing so.
        //CT.cache.views[CT.settings.currentTab].sv = sorterView;
    });
    CT.subscribe('sorters.update', function( /*Hash*/ filteredHt, /* Hash */ options) { //filteredHt = { exact : [], others : [] }
        // console.warn("CT.subscribe('sorters.update'");
        var $currentResultView = $('#ResultContainer_' + CT.settings.currentTab)
        var $topSorters = $currentResultView.find("section.secondaryBar nav.sorters a.current");
        var $currentTopSorter = $topSorters.last()
        // Only sort for tags is triggered through here!
        var sortType = $currentTopSorter.attr('data-sort');
        //for location search the sortType was undefined for first time
        if(CT && CT.cache[CT.settings.currentTab] && CT.cache[CT.settings.currentTab].setSearchTypeToLocation){
            sortType = "location" ;
        }
        if(CT && CT.cache[CT.settings.currentTab] &&
            (CT.cache[CT.settings.currentTab].searchParams.all.poi &&
                CT.cache[CT.settings.currentTab].searchParams.all.poi[0] )
             && !CT.cache[CT.settings.currentTab].searchParams.all.tagsFilter
            ){
            sortType = "location";
        }
        var otherSort = $topSorters.first().attr('data-sort');
        if ($topSorters && sortType !== otherSort || CT.cache[CT.settings.currentTab].searchParams.all.tagsFilter) {
            window.secondarySort = otherSort;
            // console.warn("otherSort", otherSort);
        }

        // In case of currentTopSorter == tags : then assign currentTopSorter = window.secondary,
        // before all class calculation and stuff
        if (CT.cache[CT.settings.currentTab].searchParams.all.tagsFilter) {
            if (CT.cache[CT.settings.currentTab].setSearchTypeToLocation) {
                window.secondarySort = 'location';
                CT.cache[CT.settings.currentTab].setSearchTypeToLocation = false;
            }
            if (!window.secondarySort) {
                window.secondarySort = 'featured';
            } else if(sortType && sortType != 'tags') {
                window.secondarySort = sortType;
                sortType = 'tags';
            }
        } else if( CT.tagsData && (!sortType || sortType == 'featured'|| sortType == 'tags') && window.secondarySort) {
            //Only if City has tags than only CT.tagsData will true
            sortType = window.secondarySort;            
        }
        //to make setSearchTypeToLocation false if above condition fails
        if (CT.cache[CT.settings.currentTab].setSearchTypeToLocation) {
            CT.cache[CT.settings.currentTab].setSearchTypeToLocation = false;
        }

        // Mark featured as the default secondary sort cause that is what the sortByTagPriority uses as a default
        var sortClassString = ".noToggle.featuredSort";
        // console.log("$topSorters", $topSorters);
        // console.log("$topSorters.length", $topSorters.length);
        if (sortType == 'tags') {
            if (window.secondarySort == 'price') {
                sortClassString = ".priceSort";
            } else if (window.secondarySort == 'ta') {
                sortClassString = ".taSort";
            } else if (window.secondarySort == 'featured') {
                sortClassString = ".featuredSort.noToggle";
            } else if (window.secondarySort == 'location') {
                sortClassString = ".location.noToggle";
            }
            $(sortClassString).addClass("current");
        }
        var sortOrder ;
        if($($currentTopSorter.prevObject[0]) && window.secondarySort == "ta"){
            sortOrder = $($currentTopSorter.prevObject[0]).hasClass('sortDes') ? 'desc' : 'asc';
        } else {
            sortOrder = $currentTopSorter.hasClass('sortDes') ? 'desc' : 'asc';
        }
        var sortedHotels = sorters.setSortedHotels(filteredHt, sortType, sortOrder)
        $currentResultView.trigger('results.update', [sortedHotels, options]);

        //Adding arrow for the first time when sortType is location
        if(sortType == "location"){
            $currentResultView.find("section.secondaryBar nav.sorters a.location").addClass("sortAsc").css("padding-right","5px");
        }
        // console.log('End of sorters.update');
    })
    CT.subscribe('sorters.triggeredOnElements', function(sorterObj) {
        //CT.settings.routes.navigate('/results?' + $.param(searchParams) , { trigger : false, replace : true })
        //CT.fire('changeRoutes',['/results?' + $.param(searchParams) , {trigger:false}]);
    });
    CT.subscribe('sorterUrlParams.set', function(paramsHash) {
        if (paramsHash)
            sorters.setUrlParams(paramsHash); // update url params only when sorters are clicked
    });
    return sorterViewSettings;
}, CT.settings);
